<template>
	<div id="shareBox" v-bind:class="{ visible: $store.state.showShareBox === true }">
		<a href="#!close" id="shareClose"><span></span><span></span></a>
		<div id="shareBackground"></div>
		<div id="shareMenu">
			
		</div>
	</div>
</template>

<script>
	export default {
		name: "Share",
	}	
</script>

<style>
	
	#shareBackground { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.4); z-index: 1005; }	
	#shareBox { display: none; }
	#shareBox.visible { display: block; }
</style>